import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArrayTextValue from '../objects/internationalizedArrayTextValue.js';
var id = 'internationalizedArrayText';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArrayTextValue'
        }
    ]
};
var validator = z.array(internationalizedArrayTextValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayText.js.map